import Tiles from "~/components/tiles"
import { scaleLinear } from "d3-scale"
import { Icon } from "evergreen-ui"
import copyIfLocal from "./copyIfLocal"

export default class Neuron extends Component {
  render() {
    const {
      layer,
      padding = 10,
      obj,
      sameLayer,
      neuron,
      isActive,
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      maxValue,
      modelName,
      size,
    } = this.props

    const gradients = obj ? obj.grad : null

    const flipped = false
    let scale

    if (gradients) {
      scale = scaleLinear().domain([0, maxValue])
    }

    const Tile =
      sameLayer || !gradients ? (
        <Surface
          width={size}
          height={size}
          background="rgba(254, 247, 237, 1)"
          alignItems="center"
          justifyContent="center"
        >
          {sameLayer && isActive && <Icon opacity={0.7} icon="star-empty" />}
        </Surface>
      ) : (
        <Tiles size={size} grad={gradients} flipped={flipped} scale={scale} />
      )

    return (
      <a
        style={{
          margin: 0,
          padding: 5,
          textDecoration: "none",
          // to overwrite Distill template
          borderBottom: "0px solid transparent",
          transition: "200ms all ease-out",
          opacity: sameLayer && !isActive ? 0.5 : 1,
        }}
        data-line-id={layer + ":" + neuron}
        onClick={
          isActive ? () => copyIfLocal({ neuron, layer, type: 0 }) : onMouseDown
        }
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Surface
          style={{
            border: isActive
              ? "3px solid rgba(228, 118, 88, 0.9)"
              : "3px solid rgba(0, 0, 0, 0.1)",
          }}
          width={size * 2}
          overflow="hidden"
          borderRadius={5}
          height={size + 6}
          position="relative"
        >
          <Surface
            flexFlow="row"
            position="absolute"
            left={0}
            top={0}
            zIndex={2000}
          >
            {!flipped && Tile}
            <div
              style={{
                overflow: "hidden",
                position: "relative",
                width: size,
                height: size,
              }}
            >
              <img
                src={neuronFeatureVis(modelName, layer, neuron)}
                alt={layer + ":" + neuron}
                width={size + padding * 2}
                height={size + padding * 2}
                style={{
                  position: "absolute",
                  left: -padding,
                  top: -padding,
                }}
              />
            </div>
            {flipped && Tile}
          </Surface>
        </Surface>
      </a>
    )
  }
}
